<template>
  <div class="summary-container mt-2">
    <h4
      id="title-summary-lianlian"
      data-testid="title-summary-lianlian"
      class="title-summary"
    >
      {{ $t('addFundPage.creditCardPayment.textSummary') }}
    </h4>
    <hr class="hr-custom">
    <div class="d-flex align-items-center justify-content-between mb-1">
      <div
        id="title-amount-lianlian"
        data-testid="title-amount-lianlian"
        class="font-14 text-placeholder"
      >
        {{ $t('balance.textAmount') }}
      </div>
      <strong
        v-if="amountValidate"
        id="current-amount-lianlian"
        data-testid="current-amount-lianlian"
      >
        {{ localStringFormat(amount) }} USD
      </strong>
      <strong v-else>
        --
      </strong>
    </div>

    <div
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        id="title-lianlian-method"
        data-testid="title-lianlian-method"
        class="font-14 text-placeholder"
      >
        {{ $t('addFundPage.creditCardPayment.textPaymentMethod') }}
      </div>
      <div
        v-if="amount"
        id="current-lianlian-method"
        data-testid="current-lianlian-method"
        class="d-flex align-items-center"
      >
        <img
          :src="require('@/assets/images/pages/payment/ic-lianlian-full.svg')"
          alt="payment"
          style="width: 121px;"
        >
      </div>
      <strong v-else> -- </strong>
    </div>

    <div
      v-if="percentFee"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        id="title-service-fee-lianlian"
        data-testid="title-service-fee-lianlian"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.balanceTransactionsTable.textServiceCharge') }}
        <small
          id="percent-service-lianlian-fee"
          data-testid="percent-service-lianlian-fee"
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${percentFeeTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amountValidate"
          id="service-charge-lianlian"
          data-testid="service-charge-lianlian"
          class="d-flex align-items-center"
        >
          <strong
            id="current-service-charge-lianlian"
            data-testid="current-service-charge-lianlian"
            class="text-primary"
          >{{ serviceCharge }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="methodFee"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        id="title-lianlian-fee"
        data-testid="title-lianlian-fee"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.paypal.textPaymentFee', { payment: 'LianLian' }) }}
        <small
          id="percent-lianlian-fee"
          data-testid="percent-lianlian-fee"
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${methodFeeTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amountValidate"
          id="lianlian-fee"
          data-testid="lianlian-fee"
          class="d-flex align-items-center"
        >
          <strong
            id="current-lianlian-fee"
            data-testid="current-lianlian-fee"
            class="text-primary"
          >{{ lianlianFee }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="taxRate"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        id="title-tax-lianlian"
        data-testid="title-tax-lianlian"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.balanceTransactionsTable.textTax') }}
        <small
          id="percent-tax-lianlian-fee"
          data-testid="percent-tax-lianlian-fee"
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${percentTaxTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amountValidate"
          id="tax-fee-lianlian"
          data-testid="tax-fee-lianlian"
          class="d-flex align-items-center"
        >
          <strong
            id="current-tax-fee-lianlian"
            data-testid="current-tax-fee-lianlian"
            class="text-primary"
          >{{ tax }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="hasAMId && tipMode"
      class="d-flex align-items-center justify-content-between"
    >
      <div
        id="title-tip-lianlian"
        data-testid="title-tip-lianlian"
        class="font-14 text-placeholder"
      >
        Tip
        <small
          v-if="currentTip > 0"
          id="percent-tip-lianlian-fee"
          data-testid="percent-tip-lianlian-fee"
          class="font-small-1"
          style="margin-right: 6px"
        >
          {{ `(${percentTipTxt})` }}
        </small>
      </div>
      <div>
        <div
          v-if="amountValidate"
          id="tip-amount-lianlian"
          data-testid="tip-amount-lianlian"
          class="d-flex align-items-center"
        >
          <strong
            id="current-tip-amount-lianlian"
            data-testid="current-tip-amount-lianlian"
            class="text-primary"
          >{{ amountTipTxt }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <hr class="hr-custom">
    <div class="d-flex align-items-center justify-content-between pb-3">
      <div
        id="title-total-amount-lianlian"
        data-testid="title-total-amount-lianlian"
        class="font-24 text-placeholder"
      >
        {{ $t('addFundPage.creditCardPayment.textTotalAmount') }}
      </div>
      <strong
        v-if="amountValidate"
        id="current-total-amount-lianlian"
        data-testid="current-total-amount-lianlian"
        class="font-24 total-amount"
      >
        {{ totalAmount }} USD
      </strong>
      <strong v-else>
        --
      </strong>
    </div>
  </div>
</template>

<script>
import paymentMixin from '@/mixins/paymentMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import numberFormatMixin from '@/mixins/numberFormatMixin'

// plugins
import { createNamespacedHelpers } from 'vuex'
import envMixin from '@/mixins/envMixin'

const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {

  mixins: [paymentMixin, generalConfigsMixin, numberFormatMixin, envMixin],

  props: {
    amount: {
      type: Number,
      required: true,
    },
    paymentMethod: {
      type: String,
      required: true,
    },
    transfer: {
      type: Object,
      required: true,
    },
    amountTip: {
      type: Number,
      required: true,
    },
    currentTip: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGettersAuth(['user', 'generalConfigs']),

    isInTrial() {
      return this.user?.isInTrial
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.lianlian || 0
    },

    percentFeeTxt() {
      return `${(this.percentFee * 100).toFixed(2)}%`
    },

    methodFee() {
      return this.generalConfigs?.paymentGateFee?.lianlianGate || 0
    },

    methodFeeTxt() {
      return `${(this.methodFee * 100).toFixed(2)}%`
    },

    percentTaxTxt() {
      return `${(this.taxRate * 100).toFixed(2)}%`
    },

    tax() {
      return this.amountFormat(this.taxRate * this.amount).toLocaleString('en-US')
    },

    percentTipTxt() {
      return `${(this.currentTip).toFixed(2)}%`
    },

    amountTipTxt() {
      return this.amountFormat(this.amountTip).toLocaleString('en-US')
    },

    totalAmount() {
      const fee = this.amountFormat(this.percentFee * this.amount)
      const tax = this.amountFormat(this.taxRate * this.amount)
      const methodFee = this.amountFormat(this.methodFee * this.amount)
      return (this.amount + fee + tax + methodFee + this.amountTip).toLocaleString('en-US')
    },

    serviceCharge() {
      return this.amountFormat(this.percentFee * this.amount).toLocaleString('en-US')
    },

    lianlianFee() {
      return this.amountFormat(this.methodFee * this.amount).toLocaleString('en-US')
    },

    amountValidate() {
      return !!(this.amount >= this.minTopUp && this.amount <= this.maxAmount)
    },

    maxAmount() {
      return 100000
    },
  },
}
</script>

<style lang="scss" scoped>
.summary-container {
  padding: 20px;
  background-color: #F5F5F7;
  // border: 1px solid rgba(22, 33, 62, 0.1);
  border-radius: 16px;

  .title-summary{
    margin-bottom: 21px;
  }
}
.transfer {
  max-width: 125px;
}

.total-amount{
  color: #00A9DE;
}
</style>
